import {
  Component, Input
} from '@angular/core';
import { Observable, of } from 'rxjs';

import { IrisButtonIconPositions, IrisButtonTypes } from '@sondermind/iris/button';
import { BreakpointsService } from '@sondermind/utilities/services';

@Component({
  selector: 'sonder-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: [
    './tooltip.component.scss',
  ],
  standalone: false
})
export class TooltipComponent {
  @Input() desktopTooltipText!: string;

  isMobile$: Observable<boolean> = of(true);
  showModal: boolean = false;
  irisButtonTypes = IrisButtonTypes;
  irisButtonIconPositions = IrisButtonIconPositions;

  constructor(
    private breakpointsService: BreakpointsService
  ) { }

  ngOnInit(): void {
    this.isMobile$ = this.breakpointsService.isMobile$;
  }

  openModal(isMobile: boolean): void {
    if (isMobile) {
      this.showModal = true;
      this.breakpointsService.toggleModal(true);
    }
  }

  closeModal(): void {
    this.showModal = false;
    this.breakpointsService.toggleModal(false);
  }
}
